<template>
    <div style="height: 100vh;" v-loading="loading" element-loading-background="rgba(0, 0, 0, 0.8)">
        <div >
            <!-- <div>
                <div>
                    <div :class="header == true ? 'block' : 'block1'">
                        <div class="pagination_box">
                            <el-input v-model="data.paginationInput" style="width: 50px" size="mini" @change="limitEvt"
                                placeholder="to"></el-input>
                            <el-pagination @current-change="handleCurrentChange" :current-page.sync="currentPage1"
                                :page-size="paginationInput - 0" layout="prev, pager, next, jumper" :total="total"
                                :pager-count="5" :show-total="showTotal">
                            </el-pagination>
                        </div>
                    </div>
                </div>
            </div> -->
            <div id="form" style="margin-top: 5px ; margin-left: 10px;">
                <span @click="cleanUpEvt" class="all_text">All</span>
                <el-date-picker v-model="value2" type="daterange" start-placeholder="开始日期" value-format="timestamp"
                    end-placeholder="结束日期" align="right" :picker-options="pickerOptions" size="mini" format="yyyy-MM-dd"
                    range-separator="-" style="width: 240px;margin-top: 5px;" @change="getList" class="border_box"
                    :class="{ 'your-css-class': !isValue2Empty }">
                </el-date-picker>
                <span style="font-size:14px;">总计 <span style="color: #409eff;">{{total}}</span></span>
            </div>
            <div>
                <div style="  display: flex; ">
                    <div v-for="item in tags" class="containerr" :key="item.id" >
                        <div>{{ item.title }}
                        </div>
                        <div v-for="res in item.children" :key="res.id" :style="{ backgroundColor: res.rgb }">
                            <span> {{ res.title}}</span>
                            <span style="color: #000;margin-left: 10px">{{res.num}}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        </div>

</template>

<script>
    import { ModeIcoMeLabelApi } from "../../../apis/income"

    export default {
        data() {
            return {
                header: true,
                src: "https://cube.elemecdn.com/6/94/4d3ea53c084bad6931a56d5158a48jpeg.jpeg",
                //备注
                remtInput: "",
                authorIdInput: "",
                localInput: "",
                last_login: "",
                //分页输入框数据
                paginationInput: 10,
                currentPage1: 1,
                //分页总数据
                total: null,
                type: 1,
                pickerOptions: {
                    shortcuts: [
                        {
                            text: "今天",
                            onClick(picker) {
                                const end = new Date();
                                const start = new Date();
                                picker.$emit("pick", [start, end]);
                                picker.$emit('pick', [new Date(start.setHours(0,0,0,0)), new Date(end.setHours(23,59,59,0))]);

                            },
                        },
                        {
                            text: "本周",
                            onClick(picker) {
                                const current = new Date();
                                let nowDayOfWeek = current.getDay();
                                if (nowDayOfWeek === 0) nowDayOfWeek = 7;
                                const dayNum = 1 * 24 * 60 * 60 * 1000;
                                const firstDate = new Date(current.valueOf() - (nowDayOfWeek - 1) * dayNum);
                                const lastDate = new Date(new Date(firstDate).valueOf() + 6 * dayNum);
                                // picker.$emit("pick", [firstDate, lastDate]);
                                picker.$emit('pick', [new Date(firstDate.setHours(0,0,0,0)), new Date(lastDate.setHours(23,59,59,0))]);

                            },
                        },
                        {
                            text: "当月",
                            onClick(picker) {
                                const date = new Date();
                                const year = date.getFullYear();
                                const month = date.getMonth();
                                let thisMonthStartDate = new Date(year, month, 1);
                                let thisMonthEndDate = new Date(year, month + 1, 0);
                                // picker.$emit("pick", [thisMonthStartDate, thisMonthEndDate]);
                                picker.$emit('pick', [new Date(thisMonthStartDate.setHours(0,0,0,0)), new Date(thisMonthEndDate.setHours(23,59,59,0))]);

                            },
                        },
                        {
                            text: "当年",
                            onClick(picker) {
                                var tYear = new Date().getFullYear();
                                var startTime = new Date(tYear, 0, 1); //当前年第一天
                                var endTime = new Date(tYear, 11, 31); //当前年最后一天
                                // picker.$emit("pick", [startTime, endTime]);
                                picker.$emit('pick', [new Date(startTime.setHours(0,0,0,0)), new Date(endTime.setHours(23,59,59,0))]);

                            },
                        },
                        {
                            text: "昨天",
                            onClick(picker) {
                                const temp = new Date();
                                temp.setTime(temp.getTime() - 3600 * 1000 * 24);
                                picker.$emit('pick', [new Date(temp.setHours(0,0,0,0)), new Date(temp.setHours(23,59,59,0))]);
                                }
                            },
                        {
                            text: "上周",
                            onClick(picker) {
                                const current = new Date(new Date().getTime() - 60 * 60 * 24 * 7 * 1000);
                                let nowDayOfWeek = current.getDay();
                                let diffToMonday =
                                    current.getDate() - nowDayOfWeek + (nowDayOfWeek === 0 ? -6 : 1);
                                const firstDate = new Date(current.setDate(diffToMonday));
                                const lastDate = new Date(current.setDate(diffToMonday + 6));
                                picker.$emit('pick', [new Date(firstDate.setHours(0,0,0,0)), new Date(lastDate.setHours(23,59,59,0))]);

                                // picker.$emit("pick", [firstDate, lastDate]);
                            },
                        },
                        {
                            text: "上月",
                            onClick(picker) {
                                var now = new Date();
                                var fd = new Date(now.getFullYear(), now.getMonth() - 1, 1);
                                var ed = new Date(now.getFullYear(), now.getMonth(), 0);
                                picker.$emit("pick", [fd, ed]);
                            },
                        },
                        {
                            text: "去年",
                            onClick(picker) {
                                var tYear = new Date().getFullYear() - 1;
                                var startTime = new Date(tYear, 0, 1);
                                var endTime = new Date(tYear, 11, 31); //当前年最后一天
                                picker.$emit("pick", [startTime, endTime]);
                            },
                        },
                    ],
                },
                value2: "",
                input: "",
                editShowInp: null,
                editName: null,
                tableData: [],
                totalRow: null,
                //排序
                data: {},
                pagefenye: false,//点击分页 滚动条为0
                loading: false,
                items: [],
                itemss: [],
                tags: [],
                tages: [],
                tableData1: [],
                isValue2Empty: true,
                c: 1,

            }
        },
        created() {

                this.loading = true
                 if (this.$store.getters.location == '') {
      this.c = 1
    }
    this.c = this.$store.getters.location;

            ModeIcoMeLabelApi({
                type: this.type,
      c:this.c,

            }).then((res) => {
                this.content = res.data
                this.items = res.data.top
                this.itemss = res.data.bottom
                this.tags = res.data.tags
                this.total = res.data.total
                this.loading = false

            })
            //监听鼠标按下抬起事件
            window.addEventListener("keydown", this.handKeyCode, true);
            window.addEventListener('keyup', this.handKeyEvt);
        },
        beforeDestroy() {
            // 在组件生命周期结束的时候销毁
            window.removeEventListener("keydown", this.handKeyCode, false);
            window.removeEventListener("keyup", this.handKeyEvt, false);
        },
        mounted() {
            //监听页面滚动条事件
            window.addEventListener("scroll", (e) => this.imgScrollEvt(e), true);
    this.c = this.$store.getters.location;

        },
        computed: {
            getStyle() {
            return num => {
                if (num == 0) {
                return "green";
                } else if (num >= 1 && num <= 10) {
                return "red"; // 默认样式
                }else if (num >= 11 && num <= 20) {
                return "blue"; // 默认样式
                }else if (num >= 21 && num <= 30) {
                return "blue"; // 默认样式
                }
            };
            }
        },
        methods: {

            //分页只显示前三页加总数
            showTotal(total) {
                return `共 ${total} 页`;
            },
            //按下键盘事件
            handKeyCode(e) {
                e = e || window.event;
            },

            limitEvt() {
                this.getList();
            },
            //滑动事件
            imgScrollEvt(e) {
            },
            //分页
            handleCurrentChange(res) {
                this.loading = true
                setTimeout(() => {
                    this.getList()
                    this.loading = false
                }, 500)
            },
            ///获取页面数据
            getList() {
                let date = {
                    start: this.value2[0],
                    end: this.value2[1],
                };
                var start = Math.floor (date.start / 1000);
                var end = Math.floor (date.end / 1000);
                // 将选定的日期转换为当天的最后一秒
                var lastVaccineDate = new Date(end * 1000);
                lastVaccineDate.setHours(23, 59, 59);
                var endTimestamp = Math.floor(lastVaccineDate.getTime() / 1000);

                ModeIcoMeLabelApi({
                    start: start,
                    end: endTimestamp,
                    type: this.type,
                    c:this.c
                }).then((res) => {
                    this.items = res.data.top
                    this.itemss = res.data.bottom
                    this.tags = res.data.tags
                    this.total = res.data.total
                })

            },

            //显示修改输入框s
            editShowEvt(e, s) {
                this.editShowInp = e.id;
                this.editName = s;
                this.$nextTick((_) => {
                    this.$refs.editInput.$refs.input.focus();
                });
            },

            //清除搜索条件
            cleanUpEvt() {
                this.value2 = '';
                ModeIcoMeLabelApi({
                    type: this.type,
                    c:this.c
                }).then((res) => {
                    this.items = res.data.top
                    this.itemss = res.data.bottom
                    this.tags = res.data.tags
                    this.total = res.data.total
                })
            }
        },
        watch: {
                '$store.getters.location': function (newLocation, oldLocation) {
                  this.c = newLocation
                },
                //修改选中日期的背景颜色
                'value2': function (newVal, oldVal) {
                    this.isValue2Empty = !newVal;
                },
            }
    };
</script>

<style lang="less" scoped>
    @import url("../../../style/income.less");

    .income_header {
        height: 35px;
        display: flex;
        align-items: center;

        span {
            font-size: 14px;
            margin-left: 20px;
        }
    }

    .containerr {
        display: flex;
        flex-direction: column;
        font-size: 14px;
        width: 120px;
        margin: 5px;
        div {
            // margin-top: 10px;
            display: flex;
            justify-content: space-between;
            padding: 5px;
        }
    }

    .container {
        /* 添加你想要的container样式 */
        white-space: nowrap;
        display: flex;
    }

    .container div {
        /* 添加你想要的子元素div样式 */
        display: flex;
        align-items: center;
        margin-right: 10px;
        /* 可根据需要调整间距 */
        font-size: 14px;
    }

    .container div .number {
        color: #f00;
        /* 数字的默认颜色 */
    }

    table {
        width: 100%;
    }

    th,
    td {
        border: 1px solid black;
        padding: 8px;
        text-align: left;
    }

    th {
        background-color: #f2f2f2;
    }


    .item {
        margin-top: 10px;
    }

    /deep/.el-input__suffix {
        color: #409eff;
    }

    /deep/.el-main {
        overflow: unset !important;
    }

    .all_text {
        background-color: #409eff;
        font-size: 13px;
        color: #fff;
        cursor: pointer;
        padding: 5px 20px;
        border-radius: 3px;
        width: 50px;
    }


    .block {
        position: fixed;
        right: calc(100% - 99.4%);
        top: 60px;
    }

    .block1 {
        visibility: hidden;
    }

    .block1>div {
        display: none;
    }



    .demo-table-expand {
        background-color: #f2f2f2;
        font-size: 0;
    }

    .demo-table-expand label {
        width: 90px;
        color: #99a9bf;
    }

    .demo-table-expand .el-form-item {
        margin-right: 0;
        margin-bottom: 0;
        padding: 0 20px;
        width: 30%;
    }

    .name_box {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;

        i {
            cursor: pointer;
            display: none;
        }
    }

    .name_box:hover>i {
        display: block;
    }

    .pagination_box {
        min-width: 500px;
        display: flex;
        align-items: center;
        justify-content: flex-end;
    }




    .notes_box {
        height: 72px;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
    }




    .clear_ev {
        position: absolute;
        right: 10px;
    }

    .vip-button {
        color: #409eff !important;
    }

    /* 朝上排序样式 */
    /deep/.el-table .ascending .sort-caret.ascending {
        background-color: #f00 !important;
        background: url("../../../img/top1.png")no-repeat -4px -3px  !important;
        background-size: 20px 20px !important;
        width: 40px;
        height: 58px;
        z-index: 11;
    }

    /* 朝下排序样式 */
    /deep/.el-table .descending .sort-caret.descending {
        background: url("../../../img/bottom1.png")no-repeat -5px 2px !important;
        background-size: 20px 20px !important;
        width: 40px;
        height: 25px;

    }

    /deep/.el-table .descending .sort-caret.descending {
        border-top-color: #fff;
    }

  /* 朝上字体样式 */
  /deep/.el-table__header .ascending  .cell{
    color: #409EFF !important;
  }
  /* 朝下字体样式 */
  /deep/.el-table__header .descending  .cell{
    color: #409EFF !important;
  }


    .your-css-class{
    background-color: #bcd9f8d4  !important;
    z-index: 9999;
    input{
      background-color:#bcd9f8d4  !important;
    }
  }
  /deep/.el-icon-circle-close:before{
    content: '' !important;
    display: none;
  }
  .leftMenu .el-menu-item.is-active{
    background-color: #F0F0F0 !important;
  }
</style>
<style>
  .your-css-class .el-range-input{
    background-color: #8fc6ff00 !important;
  }
  ::placeholder {
  color: #858585  !important;
}
.border_box{
  border: 1px solid #858585;
  border-radius: 5px
}
</style>



// WEBPACK FOOTER //
// src/Label_quantity/components/plant_statistics/index.vue